/* __next_internal_client_entry_do_not_use__ StakingInput auto */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from "./index.module.scss";
import classNames from "classnames";
import { Input } from "./Input";
import QuestionSvg from "../../assets/question.svg";
import morphIcon from "../../assets/morphIcon.webp";
import { useColor } from "../../hooks/useColor";
import { isBitkeep, getBuyUrl, handleOpenApp, formatAmount } from "../../utils";
import { useBitKeepContext } from "@/components/BitKeepProvider";
import { DrawerAmount } from "../Drawer/DrawerAmount";
import { useStore } from "../../StoreProvider";
const StakingInput = function() {
    let { className } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const t = useTranslations();
    const { accountData } = useStore();
    const [open, setOpen] = useState(false);
    const { color } = useColor();
    const walletBGBLocaleString = useMemo(()=>formatAmount(accountData.userTokenAmount), [
        accountData
    ]);
    const { bitkeep } = useBitKeepContext();
    const remainingAmountLocaleString = useMemo(()=>formatAmount(accountData.userRemainingStakeAmount), [
        accountData
    ]);
    const handleBuy = useCallback(()=>{
        if (isBitkeep) {
            bitkeep.jumpUrl(getBuyUrl());
        } else {
            handleOpenApp();
        }
    }, [
        bitkeep
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: classNames("flex flex-col gap2", className),
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex justify-between items-center",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "font-500 text-[var(--text-7)] text-15px",
                        children: t("pledgeQuantity")
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex items-center",
                        children: [
                            /*#__PURE__*/ _jsxs("svg", {
                                width: "16",
                                height: "16",
                                viewBox: "0 0 16 16",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ _jsx("path", {
                                        fillRule: "evenodd",
                                        clipRule: "evenodd",
                                        d: "M4 3H12C12.5523 3 13 3.44772 13 4V6.08535C13.1564 6.03008 13.3247 6 13.5 6C13.6753 6 13.8436 6.03008 14 6.08535V4C14 2.89543 13.1046 2 12 2H4C2.89543 2 2 2.89543 2 4V12C2 13.1046 2.89543 14 4 14H12C13.1046 14 14 13.1046 14 12V9.91465C13.8436 9.96992 13.6753 10 13.5 10C13.3247 10 13.1564 9.96992 13 9.91465V12C13 12.5523 12.5523 13 12 13H4C3.44772 13 3 12.5523 3 12V4C3 3.44772 3.44772 3 4 3Z",
                                        fill: "var(--text-3)"
                                    }),
                                    /*#__PURE__*/ _jsx("path", {
                                        d: "M8.5 8C8.5 7.17157 9.17157 6.5 10 6.5H14C14.2761 6.5 14.5 6.72386 14.5 7V9C14.5 9.27614 14.2761 9.5 14 9.5H10C9.17157 9.5 8.5 8.82843 8.5 8Z",
                                        stroke: "var(--text-3)"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "ml1 text-14px font-600",
                                children: [
                                    /*#__PURE__*/ _jsx("span", {
                                        style: {
                                            color: color.text
                                        },
                                        children: walletBGBLocaleString
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "text-[var(--text-3)] ml1",
                                        children: "BGB"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "w-14px h-14px rounded-50% ml-1.5 bg-[var(--bt-colorGreen)]",
                                onClick: handleBuy,
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: styles.add
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Input, {}),
            /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex justify-between items-center text-14px my2",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "flex items-center flex-shrink-0",
                                children: [
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "text-[var(--text-7)] opacity-60 leading-18px",
                                        children: t("remainingAmount")
                                    }),
                                    /*#__PURE__*/ _jsx("img", {
                                        src: QuestionSvg.src,
                                        onClick: ()=>setOpen(true),
                                        alt: "question",
                                        className: "w4 h4 ml1"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("span", {
                                className: "font-600 text-[var(--text-7)] leading-18px",
                                children: [
                                    remainingAmountLocaleString,
                                    " BGB"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex justify-between items-center text-14px",
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: "text-[var(--text-7)] opacity-60",
                                children: t("affiliationNetwork")
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "flex items-center",
                                children: [
                                    /*#__PURE__*/ _jsx("img", {
                                        src: morphIcon.src,
                                        alt: "question",
                                        className: "w4 h4 ml1 rounded-50% border border-solid border-#fff"
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "font-600 text-[var(--text-7)] ml1",
                                        children: "Morph"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(DrawerAmount, {
                open: open,
                onClose: ()=>setOpen(false)
            })
        ]
    });
};
export { StakingInput };
